import * as actions from '@actions'
import { useFormik } from 'formik'
import { RUNSHEET_INITIAL_VALUES } from '@constants'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Flatpickr from 'react-flatpickr'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { EditAssignedTractListModal } from '@components/tract/EditAssignedTractListModal'
import { List } from '@components/tract/List'
import './Tracts.css'
import { parseDate } from '@/utils/date'
import { useAccessUser } from '@/hook/useAccessUser'
import Checkbox from '$components/Forms/Checkbox'
import { MdInfoOutline } from 'react-icons/md'

/* type Props = {
    showAdd: boolean
    showHideAdd: (showAdd: boolean) => void
    assignTract?: Tract
    runsheetSaved?: (runsheet: Runsheet | null) => void
    initial?: Runsheet
    multipleTractsMode?: boolean
    redirect?: boolean
} */

export const UpsertRunsheet = ({
    showAdd,
    showHideAdd,
    createTractAfterwards,
    setCreateTractAfterwards,
    initial,
    closeOnSave = true,
    multipleTractsMode,
    assignTract,
    runsheetSaved,
    redirect,
    initialName = '',
    origin = '',
}) => {
    
    // @todo wtf is this
    multipleTractsMode = multipleTractsMode ?? false
    
    const navigate = useNavigate()
    
    const editMode = !!initial
    
    const [tractsList, setTractsList] = useState(
        initial?.tracts ? initial.tracts : assignTract ? [assignTract] : [],
    )
    const [showTractsList, setShowTractsList] = useState(false)
    const [showEditAssignTractsList, setShowEditAssignTractsList] = useState(false)
    const [showList, setShowList] = useState(false)
    const [assignTractsList, setAssignTractsList] = useState(tractsList)
    const [isAddTract, setIsAddTract] = useState(false)
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false)
    
    const editAccessTrack = useAccessUser({
        accessType: 'additional',
        accessName: 'edit_assigned_tracts_to_a_runsheet',
    })
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initial || { ...RUNSHEET_INITIAL_VALUES, name: initialName },
        
        // @todo this is a bug? tracts is never used, but maybe shoud be instead of 'initial.tracts'
        onSubmit: async ({ id, /* tracts, */ ...props }) => {
            if (id) {
                // const storedTractsIds = (initial?.tracts || []).map(({ id }) => id)
                // const resultTractsIds = tractsList.map(({ id }) => id)
                // const tractsIds = [...new Set([...storedTractsIds, ...resultTractsIds])]
                // const isChangedTractsList = isEqual(tractsIds, storedTractsIds)
                
                await actions.updateRunsheet(id, props)
                
                await actions.fetchRunsheetById(id)
                
                if (closeOnSave)
                    showHideAdd(!showAdd)
                return
            }
            
            if (!props.name?.trim()) return
            
            setIsSaveButtonDisabled(true)
            
            let newRunsheet = assignTract
                ? { ...(props), tracts: [assignTract?.id] }
                : { ...(props) }
            
            actions.addRunsheet(newRunsheet, runsheet => {
                if (runsheetSaved) {
                    if (runsheet && !runsheet.rdj) {
                        runsheet.rdj = []
                    }
                    
                    if (runsheet && !runsheet.tabs) {
                        runsheet.tabs = []
                    }
                    
                    runsheetSaved(runsheet)
                }
                
                if (redirect) {
                    setIsSaveButtonDisabled(false)
                    const path = runsheet ? `/runsheet/${runsheet?.id}` : 'runsheets'
                    
                    navigate(path)
                }
                
                if (closeOnSave)
                    showHideAdd(!showAdd)
            })
            
            setValues(initial || { ...RUNSHEET_INITIAL_VALUES, name: initialName })
            setIsSaveButtonDisabled(false)
        },
    })
    
    const { handleSubmit, handleChange, values, setFieldValue, setValues } = formik
    
    const handleModal = () => showHideAdd(!showAdd)
    
    const tractNames = useMemo(() => {
        const [tract] = initial?.tracts || []
        const firstAssignedUser =
            assignTractsList[0] && assignTractsList[0].assignedTo
                ? `${assignTractsList[0]?.assignedTo[0]?.firstName} ${assignTractsList[0]?.assignedTo[0]?.lastName}`
                : ''
        
        if (assignTractsList.length === 0) {
            setShowList(false)
            return 'None'
        }
        
        if (assignTractsList.length > 1) {
            setShowList(true)
            return 'Various (Click to view list)'
        }
        
        if (assignTractsList.length === 1) {
            setShowList(false)
            return `${assignTractsList[0].name} ${assignTractsList[0].grossAcreage} ${firstAssignedUser}`
        }
        
        if (!tract) {
            return ''
        }
        
        let assignedTo = ''
        
        if (tract.assignedTo?.length) {
            assignedTo = `${tract.assignedTo[0].firstName || ''} ${tract.assignedTo[0].lastName || ''}`
        }
        
        return [tract.name || '', tract.grossAcreage || '', assignedTo].join(' ')
    }, [initial?.tracts, assignTractsList])
    
    return (
        <CustomModal open={showAdd} modalHandler={() => handleModal()} center>
            <form onSubmit={handleSubmit}>
                <div>
                    <h3 className="pb-4">{editMode ? 'Edit ' : 'Add'} Runsheet</h3>
                </div>
                <div className="flex flex-col gap-4 pb-4">
                    <div className="flex items-center justify-between">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            className="input w-10/12"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Name"
                            data-test-id="UpsertRunsheetRunsheetNameInput"/>
                    </div>
                    {/* @todo Disabled this part of the code as we dont have Tracts logic yet */}
                    {editMode === '@todo disabled' && (
                        <div className="mb-4 row col-12">
                            {multipleTractsMode}
                            <div className="mb-2 flex justify-between items-center w-100">
                                <label
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={'Linked Tracts'}
                                    className="m-0">
                                    Linked Tracts
                                </label>
                                <button
                                    className="ml-3 btn btn-sm btn-primary"
                                    onClick={e => {
                                        setShowEditAssignTractsList(true)
                                        e.preventDefault()
                                    }}
                                    disabled={!editAccessTrack}>
                                    Edit Tracts
                                </button>
                            </div>
                            <span
                                className="style-as-input"
                                onClick={() => multipleTractsMode && setShowTractsList(true)}>
                                {tractNames.replace(/ /g, '\u00a0')}
                            </span>
                        </div>
                    )}
                    <div className="flex items-center justify-between">
                        <label>Status</label>
                        <select
                            className="select w-10/12"
                            name="status"
                            value={values.status}
                            onChange={handleChange}>
                            <option value=""></option>
                            <option value="assigned">Assigned</option>
                            <option value="in_progress">In Progress</option>
                            <option value="completed">Completed</option>
                        </select>
                    </div>
                    
                    <div className="flex items-center justify-between">
                        <label>Certification Date</label>
                        <Flatpickr
                            className="input w-10/12"
                            value={values.certDate}
                            name="fileDateFrom"
                            autoComplete="off"
                            placeholder="Select date"
                            options={{
                                dateFormat: 'Y-M-d',
                                allowInput: true,
                                parseDate: date => {
                                    return parseDate(date)
                                },
                            }}
                            onChange={fileDateFrom => {
                                setFieldValue('certDate', fileDateFrom[0])
                            }} />
                    </div>
                </div>
                <div className="gap-3 flex justify-end">
                    {!editMode && origin !== 'document' &&
                        <div className="flex flex-1 flex-row items-center gap-1">
                            <Checkbox
                                checked={createTractAfterwards}
                                onChange={e => setCreateTractAfterwards(e.target.checked)}
                                label="Create Tract" />
                            <span className="tooltip"
                                data-tip="Check this box to create a tract after creating the runsheet">
                                <MdInfoOutline />
                            </span>
                        </div>
                    }
                    <button
                        type="button"
                        className="btn btn-primary btn-outline"
                        onClick={() => {
                            handleModal()
                        }}>
                        Cancel
                    </button>
                    <button type="submit" disabled={!values.name || 
                        isSaveButtonDisabled} className="btn btn-primary"
                    data-test-id="UpsertRunsheetSaveButton">
                        {editMode ? 'Update ' : 'Create'}
                    </button>
                </div>
            </form>
            {showTractsList && showList && (
                <List
                    tracts={assignTractsList}
                    setShow={setShowTractsList}
                    show={showTractsList}
                    setAssignTractsList={setAssignTractsList} />
            )}
            {showEditAssignTractsList && (
                <EditAssignedTractListModal
                    setIsAddTract={setIsAddTract}
                    isAddTract={isAddTract}
                    assignedTracts={tractsList}
                    setAssignTractsList={setAssignTractsList}
                    setTracts={setTractsList}
                    setShow={setShowEditAssignTractsList}
                    show={showEditAssignTractsList} />
            )}
        </CustomModal>
    )
}
